var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.137 15.278-.718 2.44-.388 1.32a.75.75 0 0 0 .928.934l1.322-.39 2.44-.72a2.7 2.7 0 0 0 1.044-.575q.066-.057.125-.118l9.507-9.503a2 2 0 0 0 0-2.829l-1.232-1.234a2 2 0 0 0-2.828 0l-9.506 9.506a2.8 2.8 0 0 0-.694 1.169m1.438.422c.053-.175.14-.338.262-.475l.053-.056 7.141-7.138 1.938 1.938-7.138 7.14a1.26 1.26 0 0 1-.531.316l-.731.215-1.713.504.503-1.713z"
  })));
};
export default SvgPen;